export default __webpack_public_path__ + "static/media/placeholder_store01-en-mobile.1bd5e9de.png";